import React from 'react';

// Two arrows chasing each other inside a circle - the Marketplace (buy & sell) nav icon.
const SwapIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="9.25" strokeWidth={1.9} />
    <path strokeWidth={1.9} d="M8.5 10h7m0 0-2-2m2 2-2 2" />
    <path strokeWidth={1.9} d="M15.5 14h-7m0 0 2-2m-2 2 2 2" />
  </svg>
);

export default SwapIcon;
